exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".previousOwner-162cc{display:flex;align-items:center}", ""]);

// Exports
exports.locals = {
	"previousOwner": "previousOwner-162cc"
};